import {getHtml} from './html';

class SkLoading {
  constructor() {
    this.isNotShow = false;
    this.html = '';
    this.initCreate();
  }

  initCreate() {
    this.elem = document.getElementById('s-sk-loading');
    if (!this.elem) {
      this.createElement();
    } else {
      this.html = this.elem.innerHTML.replace(/[\s\r\n]+/g, '') || null;
      this.setElem();
    }
  }

  createElement() {
    this.isNotShow = true;
    const el = document.createElement('div');
    el.id = 's-sk-loading';
    this.asyncAppend(el);
  }

  asyncAppend(el) {
    if (document.body) {
      this.append(el);
    } else {
      setTimeout(() => {
        this.asyncAppend(el);
      }, 10);
    }
  }

  append(el) {
    document.body.appendChild(el);
    this.elem = document.getElementById('s-sk-loading');
    this.setElem();
  }

  setElem() {
    this.elem.className = 's-sk-loading';
    this.isShow();
  }

  isShow() {
    if (this.isNotShow) {
      this.hide();
    } else {
      this.show(this.html);
    }
  }

  show(val) {
    const html = getHtml(val);
    this.elem.innerHTML = html;
    this.elem.style.display = 'block';
  }

  hide() {
    this.elem.innerHTML = '';
    this.elem.style.display = 'none';
  }
}

const loading = new SkLoading();
export {loading};